
export function getCaseId(): string {
	const urlParams = new URLSearchParams(window.location.search)
	const caseId = urlParams.get("caseId") as string
	return  caseId || ""
}
